module.exports = __webpack_public_path__ + "static/media/screen2.b45a10e4.png";